import { Platform, Orientation } from "consts";

export const ContainerWidth = {
  [Platform.WEB]: {
    [Orientation.LANDSCAPE]: "75%",
  },
};

export const ConatinerMargin = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "140",
    [Orientation.LANDSCAPE]: "130",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "147",
    [Orientation.LANDSCAPE]: "150",
  },
};

export const RatingButtonWidthLarge = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: 90,
    [Orientation.LANDSCAPE]: 110,
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 60,
    [Orientation.LANDSCAPE]: 80,
  },
};

export const RatingButtonWidth = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: 60,
    [Orientation.LANDSCAPE]: 80,
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 30,
    [Orientation.LANDSCAPE]: 20,
  },
};

export const FontSize = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: 23,
    [Orientation.LANDSCAPE]: 23,
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 20,
    [Orientation.LANDSCAPE]: 20,
  },
};

export const ButtonPadding = {
  [Platform.WEB]: {
    [Orientation.PORTRAIT]: 10,
    [Orientation.LANDSCAPE]: 10,
  },
};

export const DescriptionFont = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: 16,
    [Orientation.LANDSCAPE]: 14,
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 12,
    [Orientation.LANDSCAPE]: 14,
  },
};

export const DescriptionFontMaxWidth = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: 86,
    [Orientation.LANDSCAPE]: 82,
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 65,
    [Orientation.LANDSCAPE]: 92,
  },
};
